const modals = {
  typeCerNum: 0,
  todoTit: '', //待办事项标题
  todoListData: [], //代办事项数据
  todoCurrent: 1, //待办事项当前页数
  todoTotal: 0, //代办事项总条数
  todoListSize: null,
  returnTodoTotal: 0, //退货单总数

  announcementTit: '', //通知标题
  announcementData: [], //通知数据
  announcementCurrent: 1, //通知当前页数
  announcementTotal: null, //通知总条数
  announcementListSize: null, //当前条数
  announcementReadData: [], // 必读公告
  readDataVisible: false, // 是否展示必读公告
  readCancelBtn: false, // 取消按钮显示
  concatObj: {}, // 联系人信息
  locationList: [], // 行政区域列表

  affixFile: {
    //附件及下载地址
    url: null,
    fileName: null,
  },
  announcementDesCreateTime: '', //创建时间
  announcementDesReleaseUserName: '', //发布人
  announcementDesText: '', //发布的内容
  announcementDesTit: '', //发布的的标题
  feedbackType: '', // 是否需要回复：0不回复  1回复
  noticeid: '', // 公告id
  affixFiles: [], //附件
  billDay: [], //对账日期
  stockWarn: 0, //库存预警数量
  waitDepotNum: 0, //待发货订单数量
  supplierCardNum: 0,
  agreeType: 0, // 同意与否
  isFirstComeIn: true,
  doSignNum: 0, // 待签署合同数量
  pendingVoucherCount: 0, // 待传凭证直送单
  rejectVoucherCount: 0, // 驳回待传凭证直送单
  pendingAppointment: 0, // 预约送货数量
  productBatchAbnormalityCount: 0, // 商品批检数量
  waitQuotedPriceCount: 0, // 待报价询问单
};

export default modals;
